export const NEWS = [
  {
    id: 1,
    title: "《雾港迷踪》正式定档，雨夜追凶片段首度曝光",
    category: "定档",
    date: "2025-10-12",
    author: "编辑部",
    readTime: "4 分钟",
    views: 18420,
    excerpt:
      "备受关注的悬疑电影《雾港迷踪》宣布定档，片方同时放出三分钟正片片段，沈砚在雨夜码头的那场独白成为讨论焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20editorial%20image%20of%20a%20film%20premiere%20poster%20wall%20with%20warm%20amber%20spotlights%20on%20a%20dark%20navy%20backdrop%2C%20abstract%2C%20no%20text%20no%20lettering&width=800&height=500&seq=hlwc-news-01&orientation=landscape",
    relatedMovieId: 1,
    content: [
      "片方今日正式公布，《雾港迷踪》将于本月底登陆全国院线，并同步释出一段三分钟的正片片段。片段中，林知远饰演的沈砚独自站在雨夜的废弃码头，面对海面说出全片最关键的一句台词。",
      "导演陈牧在采访中表示，这场戏一共拍了十七遍，前十六遍都不满意，因为「雨太大，演员的声音被盖住了，情绪也一起被盖住了」。最后一遍剧组关掉了两台降雨机，只留下码头本身的细雨。",
      "从目前曝光的物料来看，影片保持了极为克制的冷色调，港城的雾、锈迹与霓虹构成了主要的视觉元素。配乐由长期合作的 composer 完成，几乎全片没有完整旋律，只有环境声与低频。",
      "《雾港迷踪》此前在数个影展进行了小范围放映，观众反馈集中在「节奏慢但后劲大」。对于习惯强情节的观众来说，这可能不是一部轻松的片子，但它显然是今年华语悬疑中值得走进影院的一部。",
    ],
  },
  {
    id: 2,
    title: "《长夜将尽》确认开发第二季，原班人马有望回归",
    category: "资讯",
    date: "2025-10-09",
    author: "剧集观察",
    readTime: "3 分钟",
    views: 26310,
    excerpt:
      "口碑年代剧《长夜将尽》在收官一年后确认启动第二季开发，故事时间线或将推进到 2008 年，主创表示「不想重复第一季的成功公式」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20an%20old%20film%20clapperboard%20and%20script%20pages%20on%20a%20wooden%20table%20lit%20by%20a%20warm%20lamp%2C%20navy%20shadows%2C%20no%20text&width=800&height=500&seq=hlwc-news-02&orientation=landscape",
    relatedMovieId: 2,
    content: [
      "据制作方透露，《长夜将尽》第二季已进入剧本开发阶段，导演郑砚与编剧苏禾将继续搭档。故事时间线计划推进到 2008 年前后，程远与苏禾的中年生活将成为新的叙事重心。",
      "郑砚在采访中坦言，第一季的成功让他压力很大：「如果第二季只是把下岗、摆摊、拆迁再演一遍，那就没有意义了。我们想讨论的是，当日子终于好起来之后，人为什么还是会觉得空。」",
      "目前沈墨白与温以宁均已收到剧本大纲，双方团队表示档期正在协调。制片方希望在明年下半年开机，尽量保留第一季的美术与摄影班底。",
      "第一季共 24 集，至今仍在多个平台的年代剧榜单前列，被观众称为「没有反派却让人一直揪着心」的作品。",
    ],
  },
  {
    id: 3,
    title: "幕后｜林知远谈《雾港迷踪》：我把台词删掉了三分之一",
    category: "幕后",
    date: "2025-10-06",
    author: "沈一",
    readTime: "6 分钟",
    views: 12980,
    excerpt:
      "在一场长达两小时的专访里，林知远聊了聊沈砚这个角色，以及他为什么坚持在片场删掉自己的台词。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20image%20of%20a%20film%20set%20at%20night%20with%20softbox%20lights%20and%20camera%20rig%2C%20navy%20blue%20shadows%20with%20amber%20light%2C%20no%20text&width=800&height=500&seq=hlwc-news-03&orientation=landscape",
    relatedMovieId: 1,
    content: [
      "采访安排在下午三点，林知远比约定时间早到了二十分钟。他坐下来第一句话是：「我们可以先聊点别的吗，关于这部电影我已经说了太多遍标准答案。」",
      "谈到沈砚，他说最难的不是演一个警察，而是演一个「回到故乡却像个外人」的人。「他熟悉每一条街，但街上的人已经不认识他了。这种东西没法用台词说，只能站在那儿，让镜头看着你。」",
      "他提到自己删掉了剧本里大约三分之一的台词。「不是台词写得不好，是太多。人真正难受的时候话很少，你让他说完整一段，观众就不信了。」",
      "拍摄期间他几乎不与剧组的其他人社交，收工后独自沿着港口走一圈再回酒店。「我需要保持那种不被接住的状态，不然第二天一进现场就散了。」",
      "至于外界关心的奖项，他笑了笑：「我今年五十四了，如果还靠一个奖来确认自己该不该演戏，那这三十年白干了。」",
    ],
  },
  {
    id: 4,
    title: "《星轨之上》视效解析：那扇窗外的星球是怎么做出来的",
    category: "幕后",
    date: "2025-10-04",
    author: "技术组",
    readTime: "7 分钟",
    views: 9870,
    excerpt:
      "从实拍舱内到全 CG 的星球远景，《星轨之上》的视效团队分享了本季最出圈的那个长镜头背后的制作流程。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20visual%20effects%20workstation%20with%20a%20space%20scene%20on%20screen%2C%20dark%20navy%20room%20with%20amber%20desk%20lamp%2C%20no%20text&width=800&height=500&seq=hlwc-news-04&orientation=landscape",
    relatedMovieId: 3,
    content: [
      "第三集结尾，凯恩站在观察窗前，巨大的环状行星缓缓从视野边缘升起。这个持续四十七秒的镜头被观众反复截取，也成为本季讨论度最高的画面之一。",
      "视效总监透露，这个镜头其实混合了三种素材：实拍的舱内场景、用 LED 墙实时渲染的行星背景，以及后期补充的尘埃与光学耀斑。「我们尽量让演员真的看到东西，而不是对着绿幕想象。」",
      "行星的环带参考了土星与一颗系外行星的观测数据，但为了让画面更好看，团队把环带的密度降低了约百分之三十。「完全真实的物理在大银幕上会显得很脏。」",
      "整季共有 1400 多个视效镜头，其中超过六成集中在最后三集。制作周期长达十四个月，部分渲染任务在云上完成。",
    ],
  },
  {
    id: 5,
    title: "《山海食记》第九期走进苗寨，一场为返乡者准备的长桌宴",
    category: "资讯",
    date: "2025-10-02",
    author: "在地编辑部",
    readTime: "5 分钟",
    views: 15420,
    excerpt:
      "最新一期节目中，何叙在贵州苗寨待了整整九天，记录下一场为外出务工者返乡而准备的长桌宴。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20image%20of%20a%20rustic%20table%20with%20steaming%20dishes%20and%20a%20mountain%20village%20background%20in%20soft%20morning%20light%2C%20no%20text&width=800&height=500&seq=hlwc-news-05&orientation=landscape",
    relatedMovieId: 4,
    content: [
      "节目组这次没有提前联系拍摄对象，而是在寨子里住了下来，等一场宴席自然发生。第九期的长桌宴，是为二十多位在外打工的年轻人返乡准备的。",
      "何叙在节目里几乎没有提问，只是帮着洗菜、烧火、摆碗。他后来说：「你一拿出采访的架势，人家就开始说场面话了。你蹲下来择菜，他才愿意讲真的。」",
      "最打动观众的一幕，是一位老人把自家腌了三年的酸汤端上桌，说「这个他们小时候爱吃」。镜头停留了很久，没有配乐。",
      "节目播出后，寨子里的农家乐预订量明显增加。节目组在片尾特别提醒观众理性出行，不要打扰当地人的日常生活。",
    ],
  },
  {
    id: 6,
    title: "年度盘点｜2025 年最值得回看的十部华语影视作品",
    category: "榜单",
    date: "2025-09-28",
    author: "编辑部",
    readTime: "9 分钟",
    views: 33120,
    excerpt:
      "从院线悬疑到云上动画，我们选出今年在叙事、表演与影像上都有所突破的十部作品，并说明它们各自值得看的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20stack%20of%20vintage%20film%20reels%20and%20tickets%20on%20a%20dark%20navy%20surface%20with%20warm%20amber%20light%2C%20no%20text&width=800&height=500&seq=hlwc-news-06&orientation=landscape",
    relatedMovieId: 12,
    content: [
      "今年的华语影视有一个明显趋势：越来越多作品愿意把节奏放慢，把镜头留给沉默。这不一定是坏事，但它确实提高了观看的门槛。",
      "榜单第一位是《雾港迷踪》。它并不完美，中段的支线略显臃肿，但它对「故乡」这个主题的处理是今年最诚恳的。林知远的表演克制到近乎冷淡，却在一场没有台词的戏里完成全部情绪。",
      "《长夜将尽》排在第二。它最大的勇气在于拒绝把苦难浪漫化，也不给角色安排一个漂亮的翻身。二十四集结束，程远依然是个普通人，这才是最难得的。",
      "动画方面，《云端旅店》以一种近乎手作的温柔，处理了告别这件事。它没有宏大的世界观，只有一集一个旅客，却让人看完想给很久没联系的人发条消息。",
      "其余入围作品包括《云端旅店》《纸鸢与风》《逆流而上》《山海食记》第二季等。完整榜单与分项评语可在站内分类页查看。",
    ],
  },
  {
    id: 7,
    title: "《纸鸢与风》获年度动画长片奖，导演高濑优发表获奖感言",
    category: "资讯",
    date: "2025-09-20",
    author: "影展前线",
    readTime: "3 分钟",
    views: 8760,
    excerpt:
      "在本届影展上，《纸鸢与风》拿下年度动画长片奖。导演高濑优在台上说，这部片子是献给「所有没来得及告别的人」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20golden%20film%20award%20trophy%20on%20a%20dark%20stage%20with%20warm%20amber%20highlight%2C%20no%20text&width=800&height=500&seq=hlwc-news-07&orientation=landscape",
    relatedMovieId: 5,
    content: [
      "《纸鸢与风》击败四部入围作品，获得本届影展年度动画长片奖。评委会给出的评语是：「它没有试图解释世界，只是安静地陪一个孩子长大。」",
      "高濑优在台上显得有些紧张。他说这部片子做了六年，中间一度因为资金问题停摆，「最困难的时候，我把分镜贴在墙上，每天看着它们，觉得自己像个不负责的父亲」。",
      "影片全片使用手绘完成，背景美术参考了日本濑户内海一带的风景。配音方面，温以宁与苏晚的表演也被评委会特别提及。",
      "影片将于下月在国内艺术院线重映，并推出修复版原声专辑。",
    ],
  },
  {
    id: 8,
    title: "《深海回声》发布首支预告，三十七分钟的谜题浮出水面",
    category: "定档",
    date: "2025-09-15",
    author: "编辑部",
    readTime: "4 分钟",
    views: 11240,
    excerpt:
      "这支两分钟的预告几乎没有对白，只有声呐回响与舱体金属的挤压声。导演表示，声音是这部电影真正的主角。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20of%20a%20dark%20cinema%20auditorium%20with%20glowing%20empty%20screen%20and%20amber%20seat%20lights%2C%20no%20text&width=800&height=500&seq=hlwc-news-08&orientation=landscape",
    relatedMovieId: 8,
    content: [
      "预告片以一段规律的低频开始，画面全黑，只有字幕提示「每三十七分钟，它会回应一次」。直到第五十秒，观众才第一次看到潜艇的舷窗。",
      "导演理查德·拜恩在声明中说，这部电影在混音阶段花了比拍摄更长的时间。「我们不希望观众是被画面吓到，而是被自己听见的东西吓到。」",
      "白露在片中饰演生物学家诺拉，这也是她首次全程英文出演。她表示最大的挑战不是语言，而是「在一个两米见方的舱里，用身体表达恐惧」。",
      "影片已确认引进，具体档期待定。发行方提醒，影片包含较多密闭空间与低频音效，对相关敏感的观众需谨慎选择。",
    ],
  },
];